const DownloadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 16.25L16.6247 17.5H2.5V12.5H3.75V16.25H17.5ZM17.5 12.5H16.25V15H17.5V12.5ZM16.0608 9.198L15.1892 8.302L10.6251 12.7395V2.5H9.37506V12.7395L4.81088 8.302L3.93931 9.198L10.0001 15.0903L16.0608 9.198Z" fill="#111113" />
    </svg>


  )
}

export default DownloadIcon
